<template>
  <div>
    <el-page-header
      content="Increase Disk Size"
      @back="$emit('back')"
    />

    <p>Select or enter a new size for your volume. This change is <strong>not</strong> reversible.</p>

    <el-slider
      v-model="size"
      :min="instance.storage.size"
      :max="100"
      :step="5"
      :marks="{ 10: '10 GB', 30: '30 GB', 50: '50 GB', 75: '75 GB' }"
      show-input
    />

    <el-alert
      v-if="limited"
      type="error"
      title="This operation is rate-limited"
      description="one request per day"
      :closable="false"
      show-icon
    />

    <template v-else>
      <div class="align-center">
        <el-button
          type="primary"
          :disabled="size === instance.storage.size"
          @click.prevent="increase"
        >
          Resize Disk
          <span v-if="size !== instance.storage.size">
            at an additional {{ $root.currency.symbol }}{{ fee.replace(/([0-9]{2})$/, '') }} / month.
          </span>
        </el-button>
      </div>

      <el-alert
        title="Downgrading is currently not supported"
        description="Shrinking the hard disk is not possible without risking data loss."
        :closable="false"
        show-icon
      />
    </template>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  props: {
    plan: Object,
    instance: Object
  },
  data () {
    return {
      size: this.instance.storage.size
    }
  },
  computed: {
    fee () {
      return (this.storageFee(this.size) - this.storageFee(this.instance.storage.size)).toString()
    },
    limited () {
      const lastDay = moment().subtract(1, 'day').unix()
      return this.instance.storage.resized && this.instance.storage.resized > lastDay
    }
  },
  methods: {
    increase () {
      const msg = 'Once you resize, there is no going back. To confirm, please enter RESIZE below.'
      const payload = { ...this.instance }
      payload.storage.size = this.size

      this.$prompt(msg, 'This change is not reversible', {
        confirmButtonText: 'Resize Disk',
        cancelButtonText: 'Cancel',
        inputValidator: (value) => value === 'RESIZE',
        inputErrorMessage: 'Invalid input'
      }).then(() => this.$store.dispatch('increaseVolumeInstance', payload)).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-slider {
    margin: 30px 0 50px 10px;
  }
  .el-alert {
    margin-top: 50px;
  }
</style>
